import {
    Component,
    ChangeDetectionStrategy,
    Inject,
    Input,
} from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ModalController, StateService } from 'flux-core';
import { TeamPortalWindow } from '../team-portal-window/team-portal-window.cmp';
import { AccountReactivationStorage } from '../account-reactivation-window/account-reactivation-storage';

/**
 * This is the payment failed message component.
 *
 * @author shashik
 * @since 2020-12-18
 */

@Component({
    selector: 'payment-failed-message',
    templateUrl: './payment-failed-message.cmp.html',
    styleUrls: [ 'payment-failed-message.scss' ],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PaymentFailedMessage {

    /**
     * This holds value for show payment fail banner
     */
    @Input() public showPaymentFailedMessage: boolean = false;

    /**
     * Constructor
     */
    public constructor(
        @Inject( StateService ) protected state: StateService<any, any>,
        protected modalController: ModalController,
        public translate: TranslateService,
    ) {
    }

    /**
     * This will open billing page in team portal.
     */
    public showBillingPage() {
        this.markPaymentRecoveryPending();
        this.modalController.show( TeamPortalWindow , { inputs: { page: 'billing' }});
    }

    /**
     * Stores a short-lived flag so the next app boot can suppress stale payment recovery UI.
     */
    protected markPaymentRecoveryPending(): void {
        const currentUser = this.state.get( 'CurrentUser' );
        if ( !currentUser ) {
            return;
        }

        sessionStorage.setItem(
            AccountReactivationStorage.getPaymentRecoveryStorageKey( currentUser ),
            Date.now().toString(),
        );
    }

}
